// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.introjs-helperLayer {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;
}
.introjs-helperLayer.helperlayerzoomed {
  transform: scale(1.3);
}

.introjs-tooltip {
  border-radius: 10px;
}
.introjs-tooltip .introjs-button {
  background-color: #0d6efd;
  color: #FFF;
  text-shadow: none;
  border-color: #0d6efd;
  font-family: "Montserrat", sans-serif !important;
}
.introjs-tooltip .introjs-button.introjs-prevbutton.introjs-disabled {
  color: #9e9e9e;
  border-color: #bdbdbd;
  box-shadow: none;
  cursor: default;
  background-color: #f4f4f4;
  background-image: none;
  text-decoration: none;
}
.introjs-tooltip .introjs-button.introjs-prevbutton {
  color: #0d6efd;
  border-color: #0d6efd;
  box-shadow: none;
  cursor: default;
  background-color: transparent;
  background-image: none;
  text-decoration: none;
}
.introjs-tooltip .introjs-tooltip-header, .introjs-tooltip .introjs-tooltiptext {
  color: #000;
  font-family: "Montserrat", sans-serif !important;
}
.introjs-tooltip .introjs-tooltip-header .introjs-tooltip-title, .introjs-tooltip .introjs-tooltiptext .introjs-tooltip-title {
  font-family: "Montserrat", sans-serif !important;
  color: #0d6efd;
}
.introjs-tooltip .introjs-tooltip-header .introjs-skipbutton, .introjs-tooltip .introjs-tooltiptext .introjs-skipbutton {
  font-family: "Montserrat", sans-serif !important;
  font-size: 48px;
  font-weight: 300;
  color: #000;
}
.introjs-tooltip .introjs-tooltip-header .introjs-skipbutton:hover, .introjs-tooltip .introjs-tooltiptext .introjs-skipbutton:hover {
  color: #0d6efd;
}`, "",{"version":3,"sources":["webpack://./src/styles/custom_intro.scss"],"names":[],"mappings":"AAAA;EAKI,gGAAA;AAHJ;AAKI;EACI,qBAAA;AAHR;;AAOA;EAEI,mBAAA;AALJ;AAOI;EACI,yBAAA;EACA,WAAA;EACA,iBAAA;EACA,qBAAA;EACA,gDAAA;AALR;AAOQ;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,sBAAA;EACA,qBAAA;AALZ;AAQQ;EACI,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,6BAAA;EACA,sBAAA;EACA,qBAAA;AANZ;AAYI;EACI,WAAA;EACA,gDAAA;AAVR;AAYQ;EACI,gDAAA;EACA,cAAA;AAVZ;AAaQ;EACI,gDAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAXZ;AAaY;EACI,cAAA;AAXhB","sourcesContent":[".introjs-helperLayer {\r\n    //box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;\r\n\r\n    //box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;\r\n\r\n    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px, rgba(33, 33, 33, 0.5) 0px 0px 0px 5000px !important;\r\n\r\n    &.helperlayerzoomed{\r\n        transform: scale(1.3);\r\n    }\r\n  }\r\n\r\n.introjs-tooltip{\r\n\r\n    border-radius: 10px;\r\n\r\n    .introjs-button{\r\n        background-color: #0d6efd;\r\n        color: #FFF;\r\n        text-shadow: none;\r\n        border-color: #0d6efd;\r\n        font-family: \"Montserrat\", sans-serif !important;\r\n\r\n        &.introjs-prevbutton.introjs-disabled{\r\n            color: #9e9e9e;\r\n            border-color: #bdbdbd;\r\n            box-shadow: none;\r\n            cursor: default;\r\n            background-color: #f4f4f4;\r\n            background-image: none;\r\n            text-decoration: none;\r\n        }\r\n\r\n        &.introjs-prevbutton{\r\n            color: #0d6efd;\r\n            border-color: #0d6efd;\r\n            box-shadow: none;\r\n            cursor: default;\r\n            background-color: transparent;\r\n            background-image: none;\r\n            text-decoration: none;\r\n        }\r\n    }\r\n\r\n\r\n\r\n    .introjs-tooltip-header,.introjs-tooltiptext{\r\n        color: #000;\r\n        font-family: \"Montserrat\", sans-serif !important;\r\n\r\n        .introjs-tooltip-title{\r\n            font-family: \"Montserrat\", sans-serif !important;\r\n            color: #0d6efd;\r\n        }\r\n\r\n        .introjs-skipbutton{\r\n            font-family: \"Montserrat\", sans-serif !important;\r\n            font-size: 48px;\r\n            font-weight: 300;\r\n            color: #000;\r\n\r\n            &:hover{\r\n                color:#0d6efd;\r\n            }\r\n        }\r\n    }\r\n\r\n    \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
